/**
 * Safe scroll utility for the editor panel.
 *
 * `scrollIntoView()` scrolls ALL ancestor containers — including the outer
 * viewport div (which has `overflow-hidden`). This shifts the entire device
 * frame upward with no way to scroll back (no scrollbar visible).
 *
 * These helpers scroll ONLY the `#editor-scroll-container` div, leaving
 * every parent untouched.
 */

/**
 * Scroll the editor panel so that `targetEl` is visible near the top.
 * Only scrolls `#editor-scroll-container` — never parent elements.
 *
 * @param {HTMLElement} targetEl   — the DOM node to reveal
 * @param {'smooth'|'instant'} [behavior='smooth']
 */
export function scrollEditorToElement(targetEl, behavior = 'smooth') {
  if (!targetEl) return;
  const container = document.getElementById('editor-scroll-container');
  if (!container) return;

  const containerRect = container.getBoundingClientRect();
  const targetRect = targetEl.getBoundingClientRect();

  // Distance from the target's top to the container's current scroll viewport top
  const offset = targetRect.top - containerRect.top + container.scrollTop;

  container.scrollTo({ top: offset, behavior });
}

/**
 * Scroll the editor panel to a section identified by its DOM id.
 * Looks for `#section-{sectionId}` inside the editor container.
 *
 * @param {string} sectionId  — the section id suffix (e.g. 'header', 'content-order')
 * @param {'smooth'|'instant'} [behavior='smooth']
 */
export function scrollEditorToSection(sectionId, behavior = 'smooth') {
  const target = document.getElementById(`section-${sectionId}`);
  scrollEditorToElement(target, behavior);
}
